import { useQuery } from '@tanstack/react-query';
import { trpc } from '../../api/trpc';
import { isRunActive } from '../../lib/runs';

/** Runs list, polled while one is active; shared by the panel and the page. */
export function useSegmentationRuns() {
  return useQuery(
    trpc.segmentation.listRuns.queryOptions(undefined, {
      refetchInterval: (query) => (query.state.data?.some((r) => isRunActive(r.status)) ? 5000 : false),
    }),
  );
}
